module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('GChart', {
    ref: "chart",
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "type": "PieChart",
      "data": _vm.chartData,
      "options": _vm.chartOptions,
      "events": _vm.chartEvents
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-expansion-panel', _vm._l((_vm.groupedItems), function(group, groupName) {
    return _c('v-expansion-panel-content', {
      key: groupName
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v(_vm._s(groupName))]), _vm._v(" "), _vm._l((group.data), function(item) {
      return _c('v-card', {
        key: item.key
      }, [_c('v-card-text', [_vm._v(_vm._s(item.clients))])], 1)
    })], 2)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d965685"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/Dashboard.vue
// module id = 2592
// module chunks = 1